import React, { Fragment } from 'react'
import styled from 'styled-components'
import { CrownCount } from 'app/common/crown-count'
import type {
    Level as LevelType,
    SelectionScreenInfos,
    Offer
} from 'shared/types'
import { media } from 'app/assets/styles'
import { SmallText, Text } from 'app/common/typography'
import { FormattedMessage } from 'react-intl'
import { Level } from 'app/kingdom/points'
import { useSelector } from 'react-redux'
import type { RootState } from 'shared/store/reducers'
import { level } from 'shared/utils'

type Props = {
    fromEcommerce?: boolean,
    openSelectionScreen?: (
        selectionScreenInfos: SelectionScreenInfos,
        error?: string
    ) => void,
    loadingPointsTransformation?: (loading: boolean) => void
}

const Points = (props: Props) => {
    const { pointInfos, levels } = useSelector(
        (state: RootState) => state.kingdomPointsPageState
    )
    const { collectMode } = useSelector(
        (state: RootState) => state.ecommerceOrderState
    )
    const {
        fromEcommerce,
        openSelectionScreen,
        loadingPointsTransformation
    } = props

    const points = pointInfos && pointInfos.points

    return (
        <Fragment>
            {pointInfos && (
                <CrownCountContainer>
                    <CrownCount pointInfos={pointInfos} small />
                </CrownCountContainer>
            )}
            <FormattedMessage id="kingdom.points.description">
                {(text: string) => <StyledText center>{text}</StyledText>}
            </FormattedMessage>
            {levels.map((level: LevelType, index: number) => (
                <LevelContainer key={level.minPoints}>
                    <Level
                        index={index}
                        key={index}
                        points={points}
                        {...level}
                        fromEcommerce={fromEcommerce}
                        openSelectionScreen={openSelectionScreen}
                        loadingPointsTransformation={
                            loadingPointsTransformation
                        }
                        collectMode={collectMode}
                    />
                </LevelContainer>
            ))}
            {fromEcommerce && (
                <StyledSmallText>
                    <FormattedMessage id="ecommerce.discounts.kingdom.offers.footer.mention" />
                </StyledSmallText>
            )}
        </Fragment>
    )
}

const CrownCountContainer = styled.div`
    margin: 15px auto;
    ${media.medium`
        width: 50%;
        margin: 15px 0;
    `}
    ${media.large`
         width: calc(100% - 20px);
    `};
`

const LevelContainer = styled.div`
    overflow-x: hide;
    margin: 30px 0;
    ${media.medium`
        margin: 50px 0;
        width: 80%;
    `};
    ${media.large`
        width: calc(100% - 20px);
    `}
`

const StyledText = styled(Text)`
    margin: 15px auto;
`

const StyledSmallText = styled(SmallText)`
    margin-top: 50px;
`

export { Points }
